import React from "react";
import { Link } from "react-router-dom";
import api from "../../Environment";

import Slider from "../SliderView/MainSlider";
import ContentCard from "../Content/ContentCard";
import HomePageBanner from "./homePageBanner";
import HomeLoader from "../Loader/HomeLoader";
import { translate } from "react-multi-lang";
import { withToastManager } from "react-toast-notifications";
import Helper from "../Helper/helper";
import BrandAssetManager from "../../branding/BrandAssetManager";
import { fetchContentHomeRows } from "../Content/contentApi";
import { notifyShellLoadError } from "../Helper/toaster";
import ExperienceGate from "../Experience/ExperienceGate";

/** Homepage / section row title — wishlist rows use Brand Package collection label. */
function sectionTitle(maindata) {
  if (!maindata) return "";
  var urlType = String(maindata.url_type || "").toUpperCase();
  if (
    urlType === "URL_TYPE_WISHLIST" ||
    urlType === "WISHLIST" ||
    urlType.indexOf("WISHLIST") >= 0
  ) {
    return BrandAssetManager.collectionLabel();
  }
  return maindata.title || "";
}

function isSessionErrorCode(errorCode) {
  return (
    errorCode === 3000 ||
    errorCode === 3002 ||
    errorCode === 905 ||
    errorCode === 133 ||
    errorCode === 103 ||
    errorCode === 104
  );
}

class Home extends Helper {
  state = {
    maindata: null,
    errorHandle: 0,
    loading: true,
    banner: null,
    loadingHomeCatSection: true,
    homeCatData: null,
    loadingContentRows: true,
    contentRows: null,
    experience: null,
  };

  notifyHomeLoadFailure = () => {
    notifyShellLoadError(this.props.toastManager, "home");
  };

  componentDidMount() {
    const inputData = {
      page_type: "HOME",
    };
    api
      .postMethod("home_first_section", inputData)
      .then((response) => {
        if (response.data.success === true) {
          let maindata = response.data.data;
          let banner = response.data.banner;

          this.setState({
            loading: false,
            maindata: maindata,
            banner: banner,
            experience: response.data.experience || null,
          });
        } else {
          const errorCode = response.data && response.data.error_code;
          this.setState({
            loading: false,
            maindata: [],
            banner: null,
            errorHandle: 1,
            experience: null,
          });
          this.errorCodeChecker(errorCode);
          if (!isSessionErrorCode(errorCode)) {
            this.notifyHomeLoadFailure();
          }
        }
      })
      .catch(() => {
        this.setState({
          loading: false,
          maindata: [],
          banner: null,
          errorHandle: 1,
          experience: null,
        });
        this.notifyHomeLoadFailure();
      });
    api
      .postMethod("home_category_section", inputData)
      .then((response) => {
        if (response.data.success === true) {
          this.setState({
            loadingHomeCatSection: false,
            homeCatData: response.data.data,
          });
        } else {
          this.setState({
            loadingHomeCatSection: false,
            homeCatData: [],
            errorHandle: 1,
          });
          const errorCode = response.data && response.data.error_code;
          if (!isSessionErrorCode(errorCode)) {
            this.notifyHomeLoadFailure();
          }
        }
      })
      .catch(() => {
        this.setState({
          loadingHomeCatSection: false,
          homeCatData: [],
          errorHandle: 1,
        });
        this.notifyHomeLoadFailure();
      });

    // Admin-configured HomepageContentRow only (no auto Live Channels).
    fetchContentHomeRows(inputData)
      .then((body) => {
        if (body && body.success && Array.isArray(body.data)) {
          this.setState({
            loadingContentRows: false,
            contentRows: body.data,
          });
        } else {
          this.setState({ loadingContentRows: false, contentRows: [] });
          this.notifyHomeLoadFailure();
        }
      })
      .catch(() => {
        this.setState({ loadingContentRows: false, contentRows: [] });
        this.notifyHomeLoadFailure();
      });
  }

  rowItemKey(item, index) {
    return (
      item.content_item_id ||
      item.admin_video_id ||
      item.channel_id ||
      item.unique_id ||
      index
    );
  }

  renderVideoList = (maindata, index) => {
    var title = sectionTitle(maindata);
    var items = Array.isArray(maindata.data) ? maindata.data : [];
    return (
      <React.Fragment key={index}>
        <div className="main-slidersec">
          <Link
            to={{
              pathname: "/view-all",
              state: {
                url_type: maindata.url_type,
                url_type_id: maindata.url_type_id,
                page_type: "HOME",
                title: title,
              },
            }}
          >
            <h3 className="">
              {title}
              <i className="fas fa-angle-right ml-2" />
            </h3>
          </Link>

          <Slider>
            {items.map((movie, i) => (
              <ContentCard movie={movie} key={this.rowItemKey(movie, i)} />
            ))}
          </Slider>
        </div>
      </React.Fragment>
    );
  };

  renderVideoNoData = (maindata, index) => {
    return <React.Fragment key={index} />;
  };

  render() {
    const {
      loading,
      maindata,
      banner,
      loadingHomeCatSection,
      homeCatData,
      loadingContentRows,
      contentRows,
      experience,
    } = this.state;

    const firstRows = Array.isArray(maindata) ? maindata : [];
    const catRows = Array.isArray(homeCatData) ? homeCatData : [];

    return (
      <ExperienceGate destinationType="home" presentation={experience}>
      <div className="main-sec-content">
        {loading ? <HomeLoader /> : <HomePageBanner banner={banner} />}
        <div className="main p-40 home-slider-top">
          {loading
            ? ""
            : firstRows.map((mainDa, index) =>
                !mainDa.data || mainDa.data.length === 0
                  ? this.renderVideoNoData(mainDa, index)
                  : this.renderVideoList(mainDa, index)
              )}
          {loadingHomeCatSection
            ? ""
            : catRows.map((mainDa, index) =>
                !mainDa.data || mainDa.data.length === 0
                  ? ""
                  : this.renderVideoList(mainDa, "cat-" + index)
              )}
          {loadingContentRows
            ? ""
            : (contentRows || []).map((mainDa, index) =>
                !mainDa.data || mainDa.data.length === 0
                  ? ""
                  : this.renderVideoList(mainDa, "crow-" + index)
              )}

          <div className="height-100" />
        </div>
      </div>
      </ExperienceGate>
    );
  }
}

export default withToastManager(translate(Home));
